export default __webpack_public_path__ + "static/media/login-bg.48635c7d.jpg";